import { apiSlice } from '../../app/services/apiSlice';
const REPORTS_URL = 'superset/';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
   scheduleReport: builder.mutation({
      query: (data) => ({
        url: `${REPORTS_URL}scheduled-reports`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
     updateScheduleReport: builder.mutation({
      query: (data) => ({
        url: `${REPORTS_URL}scheduled-reports/${data?.id}`,
        method: 'PUT',
        body: {
          ...data,
        },
      }),
    }),
      getSupersetDashboards: builder.mutation({
      query: (params) => ({
        url: `${REPORTS_URL}dashboards`,
        params,
      }),
 transformResponse: (responseData) => {
        responseData.options = responseData?.dashboards?.map((dashboard) => ({
          ...dashboard,
          value: dashboard.id,
          label: dashboard.dashboard_title,
        }));
        return responseData || {};
      },
    }),
       getSupersetCharts: builder.mutation({
      query: (params) => ({
        url: `${REPORTS_URL}charts`,
        params,
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.charts?.map((chart) => ({
          ...chart,
          value: chart.id,
          label: chart.slice_name,
        }));
        return responseData || {};
      },
    }),
    getSupersetDashboardTabs: builder.mutation({
  query: (params) => ({
    url: `${REPORTS_URL}dashboards/${params.id}/tabs`,
    params,
  }),
  transformResponse: (responseData) => {
    // agar responseData object hai to usko map karke options bana lo
    const tabs = responseData?.data?.all_tabs || {};

    const options = Object.entries(tabs).map(([key, value]) => ({
      value: key,
      label: value,
    }));

    return { options };
  },
}),

      getSupersetChartColumns: builder.mutation({
      query: (params) => ({
        url: `${REPORTS_URL}related/${params.id}`,
        params,
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.data?.map((chart) => ({
          ...chart,
          value: chart.value,
          label: chart.text
        }));
        responseData.totalCount=responseData?.pagination?.total;
        return responseData || {};
      },
    }),
      getScheduleReports: builder.query({
      query: (params) => ({
        url: `${REPORTS_URL}scheduled-reports`,
        params,
      }),
    }),
     getScheduleReportExecution: builder.query({
      query: (params) => ({
        url: `${REPORTS_URL}scheduled-reports/${params.id}/logs`,
        params,
      }),
    }),
       getScheduleReportById: builder.query({
      query: (params) => ({
        url: `${REPORTS_URL}scheduled-reports/${params.id}`,
        params,
      }),
    }),
    deleteReport: builder.mutation({
      query: (id) => ({
        url: `${REPORTS_URL}scheduled-reports/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetSupersetChartColumnsMutation,
  useGetSupersetDashboardTabsMutation,
  useGetScheduleReportExecutionQuery,
  useDeleteReportMutation,
  useUpdateScheduleReportMutation,
  useGetScheduleReportByIdQuery,
  useGetScheduleReportsQuery,
  useScheduleReportMutation,
 useGetSupersetChartsMutation,
 useGetSupersetDashboardsMutation
} = extendedApiSlice;
